import React, { useRef } from "react";

// Six one-digit boxes for an SMS code, shared by the sign-in and sign-up dialogs (same behaviour as
// before: typing moves on, Backspace clears and moves back, a pasted or auto-filled code spreads
// across the boxes). Kit look: 44px fields, 8px corners, tabular figures.
const OtpInput = ({ length = 6, otp, setOtp, labelledBy }) => {
  const inputs = useRef([]);

  const fillFrom = (index, digits) => {
    const next = [...otp];
    let last = index;
    for (let i = 0; i < digits.length && index + i < length; i++) {
      next[index + i] = digits[i];
      last = index + i;
    }
    setOtp(next);
    inputs.current[Math.min(last + 1, length - 1)]?.focus();
  };

  const handlePaste = (e, index) => {
    const digits = (e.clipboardData?.getData("text") || "").replace(/\D/g, "");
    if (digits.length > 1) {
      e.preventDefault();
      fillFrom(index, digits);
    }
  };

  const handleChange = (e, index) => {
    const { value } = e.target;
    const digits = value.replace(/\D/g, "");
    if (digits.length > 1) {
      fillFrom(index, digits);
      return;
    }
    if (value.match(/^\d$/)) {
      const next = [...otp];
      next[index] = value;
      setOtp(next);
      if (index < length - 1) inputs.current[index + 1].focus();
    } else if (value === "") {
      const next = [...otp];
      next[index] = "";
      setOtp(next);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const next = [...otp];
      next[index] = "";
      setOtp(next);
      if (index > 0) inputs.current[index - 1].focus();
    }
  };

  return (
    <div className="fn-otp" role="group" aria-labelledby={labelledBy}>
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          aria-label={`Digit ${index + 1} of ${length}`}
          className="fn-field fn-num fn-otp-box"
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onPaste={(e) => handlePaste(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
